import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircle = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	height: 24,
	width: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 4,
		fill: "currentcolor"
	})]
});
export default SvgCircle;
